export const SET_FULL_LOADER_COMMON = 'common/SET_LOADER'

export const SET_QUIZ = 'quiz/SET_QUIZ'
export const SET_QUESTION = 'quiz/SET_QUESTION'
export const VALIDATE_QUESTION = 'quiz/VALIDATE_QUESTION'
export const SET_RESPONSE_SCORE = 'quiz/SET_RESPONSE_SCORE'



// WEBPACK FOOTER //
// ./src/store/types.js